import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {Privilege} from '../models/privilege';

@Injectable()
export class PrivilegeService {

  /**
   * Load dependencies
   * @param {ApiService} apiService
   */
  constructor(private apiService: ApiService) {
  }

  /**
   * Fetch all settable privileges from the API
   * @returns {Observable<any>}
   */
  getSettablePrivileges() {
    return this.apiService.get('Privilege/GetAll').map((res) => {
      if (res && res.values) {
        return res.values.map(value => new Privilege(value));
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/privilege.service.ts